import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { useTheme } from "@/contexts/theme";
import { FONT_FAMILY } from "@/utils/font-family";
import { useMemo } from "react";

const useStyle = () => {
  const { primaryColor, theme } = useGomakeTheme();
  const { currentTheme } = useTheme();
  const isHpClient = currentTheme === "hp-client";

  const classes = useMemo(() => {
    return {
      insideStyle: { width: "85%" },
      menuItemContainer: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 8,
        padding: 15,
      },
      menuTitleStyle: {
        ...FONT_FAMILY.Lexend(500, 12),
        color: primaryColor(300),
      },
      lineStyle: {
        width: "100%",
        height: 1,
        backgroundColor: "#EEEEEE",
      },
      menuRowStyle: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 8,
        padding: isHpClient
          ? "var(--theme-combobox-item-padding, 6px 12px 6px 8px)"
          : undefined,
        minHeight: isHpClient
          ? "var(--theme-combobox-item-min-height, 36px)"
          : undefined,
        borderRadius: isHpClient
          ? "var(--theme-combobox-item-radius, 8px)"
          : undefined,
      },
      menuRowSx: isHpClient
        ? {
            "&:hover": {
              backgroundColor:
                "var(--theme-combobox-item-hover-bg, rgba(26, 26, 26, 0.06))",
            },
          }
        : undefined,
      rowTextStyle: {
        ...(isHpClient
          ? {
              fontFamily: "'Forma DJR UI', Lexend, sans-serif",
              fontWeight: 400,
            }
          : FONT_FAMILY.Lexend(500, 10)),
        color: `var(--theme-combobox-label-color, ${primaryColor(300)})`,
        fontSize: "var(--theme-combobox-label-font-size, 12px)",
        lineHeight: "var(--theme-combobox-label-line-height, 16px)",
        textDecoration: "unset",
        display: "block",
      },
    };
  }, [theme, currentTheme]);
  return {
    classes,
  };
};
export { useStyle };
